import { API as e, PrivilegeFilterType as t, Resource as n } from "@coveo/platform-client";
// src/resources/OrganizationInternalResource.ts
var r = class r extends n {
	static {
		this.baseUrl = `/rest/organizations/${e.orgPlaceholder}`;
	}
	static {
		this.privilegesUrl = `/api/private/organizations/${e.orgPlaceholder}/privileges`;
	}
	getResourceHealth(e) {
		return this.api.get(this.buildPath(`${r.baseUrl}/resource-health`, { resourceType: e }));
	}
	listPrivileges() {
		return this.api.get(r.privilegesUrl);
	}
	listApiKeysPrivileges(e = { filter: t.ALL }) {
		return this.api.get(this.buildPath(`${r.privilegesUrl}/apikeys`, e));
	}
};
export { r as OrganizationInternalResource };

//# sourceMappingURL=OrganizationInternalResource.js.map